var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightpricechange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-exchange-alt",
    "data-name": "Icon awesome-exchange-alt",
    d: "M0,9.536v-.8a1.093,1.093,0,0,1,.937-1.2H15v-2.4c0-1.068,1.012-1.6,1.6-.848l3.125,4a1.448,1.448,0,0,1,0,1.7l-3.125,4c-.587.751-1.6.224-1.6-.848v-2.4H.937A1.093,1.093,0,0,1,0,9.536Zm19.063,7.6H5v-2.4c0-1.066-1.01-1.6-1.6-.848l-3.125,4a1.448,1.448,0,0,0,0,1.7l3.125,4c.587.751,1.6.223,1.6-.848v-2.4H19.063a1.093,1.093,0,0,0,.938-1.2v-.8A1.093,1.093,0,0,0,19.063,17.136Z",
    transform: "translate(-3.936 20) rotate(-90)",
    fill: "#F39C12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightpricechange);
export default __webpack_public_path__ + "static/media/lightpricechange.795a58c3ee75052cb70bfababd992bb4.svg";
export { ForwardRef as ReactComponent };